import * as LINK from "./constants/Links";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import LaunchpadCreate from "./pages/launchpad/create";
import LaunchpadCreateFair from "./pages/launchpad/createFair";
import LaunchpadCreateSubScriptionPool from "./pages/launchpad/createSubScriptionPool";

import LaunchpadCreateDutchAuction from "./pages/launchpad/createDutchAuction";
import LaunchpadCreateToken from "./pages/launchpad/createToken";
import LaunchpadList from "./pages/launchpad/List";
import LaunchpadGC from "./pages/launchpad/GC";
import PrivateSale from "./pages/privatesale/Private";
import PrivateList from "./pages/privatesale/PrivateList";

import Pinklock from "./pages/pinklock/Pinklock";
import PinlockToken from "./pages/pinklock/PinlockToken";
import PinlockList from "./pages/pinklock/PinlockList";
import PinklockViewDetail from "./pages/pinklock/PinklockViewDetail";
import Pinklockrecord from "./pages/pinklock/Pinklockrecord";

import Airdrop from "./pages/airdrop/Airdrop";
import AirdropList from "./pages/airdrop/AirdropList";
import LeaderBoard from "./pages/LeaderBoard/index";
import Antibot from "./pages/antibot/index";
import MultiSender from "./pages/multisender/index";
const routers = [
  {
    path: LINK.HOME,
    name: "homePage",
    exact: false,
    main: ({ match, history, routers }) => (
      <Home match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD,
    name: "LaunchpadCreate",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadCreate match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD_CREATE_FAIR,
    name: "LaunchpadCreateFair",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadCreateFair match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD_CREATE_SUB_SCIPTION_POOL,
    name: "LaunchpadCreateSubScriptionPool",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadCreateSubScriptionPool match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD_CREATE_TOKEN,
    name: "LaunchpadCreateToken",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadCreateToken match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD_CREATE_DUTCH_AUTION,
    name: "LaunchpadCreateDutchAuction",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadCreateDutchAuction match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD_LIST,
    name: "LaunchpadList",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadList match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LAUNCHPAD_GC,
    name: "LaunchpadGC",
    exact: false,
    main: ({ match, history, routers }) => (
      <LaunchpadGC match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PRIVATESALE,
    name: "PrivateSale",
    exact: false,
    main: ({ match, history, routers }) => (
      <PrivateSale match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PRIVATESALE_LIST,
    name: "PrivateList",
    exact: false,
    main: ({ match, history, routers }) => (
      <PrivateList match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PINKLOCK,
    name: "Pinklock",
    exact: false,
    main: ({ match, history, routers }) => (
      <Pinklock match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PINKLOCK_TOKEN,
    name: "PinlockToken",
    exact: false,
    main: ({ match, history, routers }) => (
      <PinlockToken match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PINKLOCK_LIST,
    name: "PinlockList",
    exact: false,
    main: ({ match, history, routers }) => (
      <PinlockList match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PINKLOCK_DETAIL,
    name: "PinklockViewDetail",
    exact: false,
    main: ({ match, history, routers }) => (
      <PinklockViewDetail match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.PINKLOCK_RECORD,
    name: "Pinklockrecord",
    exact: false,
    main: ({ match, history, routers }) => (
      <Pinklockrecord match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LEADER_BOARD,
    name: "LeaderBoard",
    exact: false,
    main: ({ match, history, routers }) => (
      <LeaderBoard match={match} history={history} routers={routers} />
    ),

  },

  {
    path: LINK.AIRDROP,
    name: "Airdrop",
    exact: false,
    main: ({ match, history, routers }) => (
      <Airdrop match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.AIRDROP_LIST,
    name: "AirdropList",
    exact: false,
    main: ({ match, history, routers }) => (
      <AirdropList match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.ANTIBOT,
    name: "Antibot",
    exact: false,
    main: ({ match, history, routers }) => (
      <Antibot match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.MULTI_SENDER,
    name: "MultiSender",
    exact: false,
    main: ({ match, history, routers }) => (
      <MultiSender match={match} history={history} routers={routers} />
    ),

  },
  {
    path: LINK.LOGIN,
    exact: false,
    name: "login",
    main: ({ match, location, history }) => (
      <Login match={match} history={history} location={location} />
    ),
  },


  // {
  //   path: "/categories/:cate?",
  //   exact: true,
  //   main: ({ match, location, history }) => (
  //     <Archive match={match} history={history} location={location} />
  //   ),
  // },
  // {
  //   path: "/tags/:tag",
  //   exact: true,
  //   main: ({ match, history, location }) => (
  //     <Tags match={match} history={history} location={location} />
  //   ),
  // },
  // {
  //   path: "/search/:search",
  //   exact: true,
  //   main: ({ match, history }) => (
  //     <SearchPage match={match} history={history} />
  //   ),
  // },
  // {
  //   path: "",
  //   exact: true,
  //   main: () => <NotFound />,
  // },
];

export default routers;
